import { React } from 'react';

import style from "../Loader/index.module.css";



const Loader = () => {
    return(
       
        <div className={style.loader}>
        <h1>  </h1>   
        <img src="/loader.gif" alt='Loading' width="112" height="112" />
         
        </div>
       





    )        
}

export default Loader;
